import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import {
	DateString,
	FormattedText,
	Space,
	Typography
} from "client/Components";
import styles from "./MaintenanceActivity.module.less";
import { useUserTimezone } from "client/Hooks";
import { TimeZone } from "client/DateAndTime/timezones";
import { MaintenanceNotificationDataViewModel, MaintenanceNotificationKind } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";

export type MaintenanceActivityProps = {
	data: MaintenanceNotificationDataViewModel;
};

export const plannedMaintenanceMessageKey: { [key in MaintenanceNotificationKind]: LocalizationKey } = {
	[MaintenanceNotificationKind.Regular]: "_PlannedMaintenanceForAppName",
	[MaintenanceNotificationKind.Updated]: "_UpdatedPlannedMaintenanceForAppName",
	[MaintenanceNotificationKind.Cancelled]: "_CancelledPlannedMaintenanceForAppName"
};

export const MaintenanceActivity = (props: MaintenanceActivityProps): ReactElement => {
	const { data } = props;

	const {
		kind,
		start,
		end
	} = data;

	const userTimezone: TimeZone = useUserTimezone();

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize(plannedMaintenanceMessageKey[kind])}
				thingsToReplace={
					[
						{
							what: "{AppName}",
							filler: (
								<Typography
									trackingId="app-name"
									weight="bold"
								>
									{data.appName}
								</Typography>
							)
						}
					]
				}
			/>
			{(kind === MaintenanceNotificationKind.Regular || kind === MaintenanceNotificationKind.Updated) && (
				<>
					<Space />
					<span className={styles.dateContainer}>
						<Typography weight="bold">{localize("_Starts") + ": "}</Typography>
						<DateString
							value={start}
							format="DMYT"
							timezone={userTimezone}
						/>
					</span>
					<Space />
					<span className={styles.dateContainer}>
						<Typography weight="bold">{localize("_Ends") + ": "}</Typography>
						<DateString
							value={end}
							format="DMYT"
							timezone={userTimezone}
						/>
					</span>
				</>
			)}
		</span>
	);
};

MaintenanceActivity.displayName = "MaintenanceActivity";